import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=7928824e&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=7928824e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7928824e",
  null
  
)

export default component.exports